const trapFocusHandlers = {};

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

function trapFocus(container) {
    var elementToFocus =
        arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : container;
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.

        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        } //  On the first focusable element and tab backward, focus the last element.

        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

class CartNotification extends HTMLElement {
    constructor() {
        super();

        this.notification = document.getElementById("cart-notification");
        this.header = document.querySelector("sticky-header");
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener(
            "keyup",
            (evt) => evt.code === "Escape" && this.close()
        );
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener("click", this.close.bind(this))
        );
    }

    open() {
        this.notification.classList.add("animate", "active");

        this.notification.addEventListener(
            "transitionend",
            () => {
                this.notification.focus();
                trapFocus(this.notification);
            },
            { once: true }
        );

        document.body.addEventListener("click", this.onBodyClick);
    }

    close() {
        this.notification.classList.remove("active");

        document.body.removeEventListener("click", this.onBodyClick);

        removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            document.getElementById(section.id).innerHTML =
                this.getSectionInnerHTML(
                    parsedState.sections[section.id],
                    section.selector
                );
        });

        if (this.header) this.header.reveal();
        this.open();
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-notification-product",
                selector: `#cart-notification-product-${this.productId}`,
            },
            {
                id: "cart-notification-button",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (
            target !== this.notification &&
            !target.closest("cart-notification")
        ) {
            const disclosure = target.closest("details-disclosure");
            this.activeElement = disclosure
                ? disclosure.querySelector("summary")
                : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-notification", CartNotification);
